import { render } from "./attachmentItem.vue?vue&type=template&id=30cc1ed0&scoped=true"
import script from "./attachmentItem.vue?vue&type=script&lang=js"
export * from "./attachmentItem.vue?vue&type=script&lang=js"

import "./attachmentItem.vue?vue&type=style&index=0&id=30cc1ed0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30cc1ed0"]])

export default __exports__